import type { LottieElementSpec, LottieSlotValue } from './types';

function parseSpec(el: Element): LottieElementSpec {
  let slots: Record<string, LottieSlotValue> = {};
  try {
    const raw = el.getAttribute('data-lottie-slots');
    if (raw) slots = JSON.parse(raw) as Record<string, LottieSlotValue>;
  } catch {
    slots = {}; // malformed attr — render with defaults rather than fail
  }
  return {
    cfNodeId: el.getAttribute('data-cf-id') ?? '',
    ref: el.getAttribute('data-lottie') ?? '',
    loop: el.getAttribute('data-lottie-loop') !== 'false',
    autoplay: el.getAttribute('data-lottie-autoplay') !== 'false',
    speed: Number(el.getAttribute('data-lottie-speed') ?? '1') || 1,
    slots,
  };
}

/** All data-lottie elements in an html string (for snapshots/clip lanes). */
export function lottieElementsOf(html: string): LottieElementSpec[] {
  const host = document.createElement('div');
  host.innerHTML = html;
  return scanRoot(host);
}

/** Same, over a live root (for the hook — reads the rendered DOM). */
export function scanRoot(root: ParentNode): LottieElementSpec[] {
  return Array.from(root.querySelectorAll('[data-lottie]')).map(parseSpec);
}
